import React, { useState } from 'react';
import { XIcon, PencilIcon, BookOpenIcon } from 'lucide-react';
type StoryPreviewProps = {
  story: string;
  onClose: () => void;
  onEdit: () => void;
  onCreate: () => void;
};
export const StoryPreview = ({
  story,
  onClose,
  onEdit,
  onCreate
}: StoryPreviewProps) => {
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50" data-id="element-1035">
     <div className="bg-white rounded-2xl w-full max-w-4xl p-6" data-id="element-1036">
       <div className="flex items-center justify-between mb-6" data-id="element-1037">
         <h2 className="text-xl font-bold text-purple-700" data-id="element-1038">
           Your Story Preview
         </h2>
         <button onClick={onClose} className="p-2 hover:bg-purple-100 rounded-full transition-colors" data-id="element-1039">
           <XIcon size={20} className="text-purple-700" data-id="element-1040" />
         </button>
       </div>
       
       <div className="bg-purple-50 rounded-xl p-6 mb-6 max-h-[60vh] overflow-y-auto" data-id="element-1041">
         <p className="text-lg text-purple-800 leading-relaxed whitespace-pre-wrap" data-id="element-1042">
           {story}
         </p>
       </div>
       
       <div className="flex justify-end space-x-4" data-id="element-1043">
         <button onClick={onEdit} className="px-6 py-3 rounded-full border-2 border-purple-200 text-purple-600 hover:bg-purple-50 transition-colors flex items-center" data-id="element-1044">
           <PencilIcon size={20} className="mr-2" data-id="element-1045" />
           Edit Story
         </button>
         <button onClick={onCreate} className="px-6 py-3 bg-purple-600 text-white rounded-full hover:bg-purple-700 transition-colors flex items-center" data-id="element-1046">
           <BookOpenIcon size={20} className="mr-2" data-id="element-1047" />
           Create My Story!
         </button>
       </div>
     </div>
   </div>;
};